import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import AddEditRole from './AddEditRole';
import RoleTable from './RoleTable';
import './role.less';

const RoleWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.ROLE}`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.ROLE}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <RoleTable {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.ROLE}/add`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.ROLE}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <AddEditRole {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.ROLE}/edit/:roleById`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.ROLE}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <AddEditRole {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);
export default RoleWrapper;
